import { appendQueryParams } from "common/helpers/utils"
import { BlockExplorerType } from "web3/constants/chains"
import { getChainByReference } from "web3/helpers/findChain"

// this will work for most cases, especially with etherscan API
// a stronger method will be to use ethers to check for methods within the contract like `totalSupply()` for example
export const isTokenAddress = async (
  chainReference: number,
  address: string,
): Promise<boolean> => {
  const foundChain = getChainByReference(chainReference)

  if (!foundChain) {
    return false // can't really determine if token or not
  }

  // TODO(@nicolas): Temporary fix to support both Etherscan v1 and v2 in Prod and Staging
  const apiKey =
    foundChain.blockExplorer?.type === BlockExplorerType.Etherscan
      ? process.env.NEXT_PUBLIC_ETHERSCAN_API_KEY
      : foundChain.envExplorerArg && foundChain.envExplorerArg.length > 0
      ? (process.env[foundChain.envExplorerArg] as string)
      : ""
  const requestUrl = appendQueryParams({
    url: foundChain?.blockExplorer?.apiUrl ?? "",
    queryParams: `module=stats&action=tokensupply&contractaddress=${address}&apikey=${apiKey}`,
  })

  try {
    const response = await fetch(requestUrl)

    if (!response.ok) {
      return false // can't really determine if token or not
    }

    const data = await response.json()

    // have to use data.result !== '0' as it seems to be the default result for all addresses
    if (
      data.status === "1" &&
      data.result &&
      data.result.length > 0 &&
      data.result !== "0"
    ) {
      return true
    }

    return false // can't really determine if token or not
  } catch (error) {
    return false // can't really determine if token or not
  }
}
